import { Directive, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[noWhitespace][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: NoWhitespaceDirective, multi: true}],
  standalone: false,
})
export class NoWhitespaceDirective implements Validator {
  @Input() max: number;
  @Input() optional = false;

  validate(c: UntypedFormControl): {[key: string]: any} {
    const v = c.value;
    const isWhitespace = (v || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid || this.optional ? null : { 'noWhitespace': true };
  }
}
